import { useEffect, useState } from 'react';
import { subscribeMyGroupMemberships } from '../api/groupService';

/** Live list of the signed-in user's league memberships. */
export function useGroupMemberships(userId) {
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    if (!userId) {
      setMemberships([]);
      return undefined;
    }
    return subscribeMyGroupMemberships(userId, setMemberships, () => setMemberships([]));
  }, [userId]);

  return memberships;
}
